module.exports = __webpack_public_path__ + "static/media/Banner(Book-II).634cae2c.jpg";